export let TimelineGridEventDataAttributes = /*#__PURE__*/function (TimelineGridEventDataAttributes) {
  /**
   * Present when the event start date is in the past.
   */
  TimelineGridEventDataAttributes["started"] = "data-started";
  /**
   * Present when the event end date is in the past.
   */
  TimelineGridEventDataAttributes["ended"] = "data-ended";
  /**
   * Present when the event is being dragged.
   */
  TimelineGridEventDataAttributes["dragging"] = "data-dragging";
  /**
   * Present when the event is being resized.
   */
  TimelineGridEventDataAttributes["resizing"] = "data-resizing";
  /**
   * Present when the event starts before the visible timeline range.
   */
  TimelineGridEventDataAttributes["startingBeforeEdge"] = "data-starting-before-edge";
  /**
   * Present when the event ends after the visible timeline range.
   */
  TimelineGridEventDataAttributes["endingAfterEdge"] = "data-ending-after-edge";
  return TimelineGridEventDataAttributes;
}({});